import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { resetForm } from 'State/forms/actions';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import {
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_FOR_SERVER,
  UNSAVED_MESSAGE,
} from 'Common/Constants';
import { CREATE_EDIT_ADJUSTMENT_FORM_NAME } from 'Common/FormEnum';
import { NewEditAdjustmentEnum } from 'Common/Constants/Enumeration/AdjustmentListEnum';
import { FilterEnum, AdjustmentEnum } from 'Common/FieldEnum';
import { NotificationDialog } from 'Components';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { resetDirty } from 'State/dirtyTracking/actions';
import * as FilterSelectors from 'State/filters/selectors';

import { actions } from './../../state/actions';
import CreateEditAdjustmentComponent from '../../components/createEditAdjustment/CreateEditAdjustmentComponent';
import * as CreateEditSelectors from '../../state/createEditAdjustment/selectors';

class CreateEditAdjustmentContainer extends Component {
  static propTypes = {
    resetForm: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
    key: PropTypes.string,
    initialValues: PropTypes.object.isRequired,
    TransactionId: PropTypes.string.isRequired,
    IsNewEdit: PropTypes.string,
    isDisabled: PropTypes.bool,
    fetchingAdjustmentItems: PropTypes.bool,
    showNotificationModal: PropTypes.bool,
    hideNotificationModal: PropTypes.func,
    message: PropTypes.string,
    resetPageOnDataChange: PropTypes.bool,
    onResetPageOnDataChange: PropTypes.func,

    adjustmentDT: PropTypes.string,
    adjustmentItemsInfo: PropTypes.array,
    Site: PropTypes.string,
    assignItemsBidGroupData: PropTypes.array.isRequired,
    assignItemsItemGroupData: PropTypes.array.isRequired,
    adjustmentItemsData: PropTypes.array.isRequired,
    fetchingAdjustmentDetail: PropTypes.bool,
  };
  static defaultProps = {
    IsNewEdit: NewEditAdjustmentEnum.NEW,
    isDisabled: false,
    fetchAdjustmentItems: false,
    showNotificationModal: false,
    hideNotificationModal: () => {},
    message: '',
    resetPageOnDataChange: true,
    onResetPageOnDataChange: () => {},
    adjustmentDT: moment().format(DATE_FORMAT_FOR_UI),
    Site: GenericEnum.EmptyString,
    fetchingAdjustmentDetail: false,
    adjustmentItemsInfo: [],
    key: 'newEdit1',
  };
  state = {
    showUnsavedSiteDateModal: false,
    showUnsavedFiltersModal: false,
    filterValues: {
      [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
    },
    SiteAndDeliveryDate: {
      newValue: null,
      prevValue: null,
      field: '',
    },
  };

  componentDidUpdate = () => {
    const { IsNewEdit } = this.props;
    if (IsNewEdit === NewEditAdjustmentEnum.VIEW) {
      this.props.resetDirty();
    }
  };

  handleChange = (e, values) => {
    this.setState({ filterValues: values }, () => this.getFilterData());
  };

  handleUnsavedSiteDateDialog(result) {
    if (result) {
      this.setState({ showUnsavedSiteDateModal: false });
      this.getFilterData();
    } else {
      const { prevValue, field } = this.state.SiteAndDeliveryDate;
      field === AdjustmentEnum.Site
        ? this.props.change([AdjustmentEnum.Site], prevValue)
        : this.props.change([AdjustmentEnum.TransactionDT], prevValue);
      this.setState({
        showUnsavedSiteDateModal: false,
      });
    }
  }

  handleUnsavedFilterDialog(result) {
    if (result) {
      this.clearFilters();
    } else {
      this.setState({ showUnsavedFiltersModal: false });
    }
  }

  handleClearFilters = () => {
    const { adjustmentItemsInfo } = this.props;
    if (adjustmentItemsInfo && adjustmentItemsInfo.length) {
      this.setState({
        showUnsavedFiltersModal: true,
      });
    } else {
      this.clearFilters();
    }
  };
  clearFilters = () => {
    const { IsNewEdit, TransactionId } = this.props;

    const filterValues = {
      [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
    };
    this.setState({
      filterValues: filterValues,
      showUnsavedFiltersModal: false,
    });
    this.props.resetForm(CREATE_EDIT_ADJUSTMENT_FORM_NAME);
    if (IsNewEdit !== NewEditAdjustmentEnum.NEW) {
      this.props.getAdjustmentDetail(TransactionId);
    } else {
      this.props.emptyItemList();
    }
  };

  onChangeOfSiteAndDate = (e, newValue, prevValue, field) => {
    if (newValue === prevValue) {
      return;
    }
    if (
      newValue !== prevValue &&
      prevValue !== NewEditAdjustmentEnum.NEW &&
      this.props.adjustmentItemsInfo.length
    ) {
      this.setState({
        showUnsavedSiteDateModal: true,
        SiteAndDeliveryDate: {
          newValue,
          prevValue,
          field,
        },
      });
    } else {
      this.getFilterData(newValue, prevValue, field);
    }
  };

  getFilterData = (newValue, prevValue, field) => {
    const { IsNewEdit, adjustmentDT, TransactionId, Site } = this.props;
    let site = Site;
    let adjustmentDate = adjustmentDT;
    if (field === AdjustmentEnum.Site) {
      site = newValue;
    }
    if (field === AdjustmentEnum.TransactionDT) {
      adjustmentDate = newValue;
    }
    const filtersOptions = {
      SiteId: site,
      TransactionDt: moment(adjustmentDate).format(DATE_FORMAT_FOR_SERVER),
    };
    if (adjustmentDate && site) {
      this.props.getAdjustmentItems(filtersOptions).then(() => {
        if (IsNewEdit !== NewEditAdjustmentEnum.NEW) {
          this.props.getAdjustmentDetail(TransactionId);
        }
        if (
          this.props.adjustmentItemsInfo &&
          this.props.adjustmentItemsInfo.length
        ) {
          let adjustmentList = [];
          this.props.adjustmentItemsData.forEach(item => {
            _.some(this.props.adjustmentItemsInfo, obj => {
              if (
                item[AdjustmentEnum.ItemCode] === obj[AdjustmentEnum.ItemCode]
              ) {
                adjustmentList.push(obj);
                return true;
              }
            });
          });
          this.props.setModifiedAdjustmentItems(adjustmentList);
          this.props.reorderItemList(adjustmentList);
        }
      });
    }
  };

  render() {
    const {
      adjustmentItemsData,
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      IsNewEdit,
      fetchingAdjustmentItems,
      showNotificationModal,
      hideNotificationModal,
      message,
      Site,
      fetchingAdjustmentDetail,
      resetPageOnDataChange,
      onResetPageOnDataChange,
    } = this.props;

    const {
      filterValues,
      showUnsavedFiltersModal,
      showUnsavedSiteDateModal,
    } = this.state;
    const filterValuesData = {};
    _.map(filterValues, (value, key, items) => {
      if (+items[key]) {
        filterValuesData[key] = items[key];
      }
    });

    const newData = Object.keys(filterValuesData).length
      ? _.filter(adjustmentItemsData, filterValuesData)
      : adjustmentItemsData;
    return (
      <Fragment>
        <CreateEditAdjustmentComponent
          isDisabled={this.props.isDisabled}
          IsNewEdit={IsNewEdit}
          assignItemsBidGroupData={assignItemsBidGroupData}
          assignItemsItemGroupData={assignItemsItemGroupData}
          clearFilters={this.handleClearFilters}
          handleChange={this.handleChange}
          filterValues={filterValues}
          onChangeOfSite={this.onChangeOfSiteAndDate}
          onChangeOfAdjustmentDT={this.onChangeOfSiteAndDate}
          adjustmentItemsData={newData}
          fetchingAdjustmentItems={fetchingAdjustmentItems}
          fetchingAdjustmentDetail={fetchingAdjustmentDetail}
          selectedSiteID={Site}
          resetPageOnDataChange={resetPageOnDataChange}
          onResetPageOnDataChange={onResetPageOnDataChange}
        />
        <YesNoDialog
          showDialog={showUnsavedFiltersModal || showUnsavedSiteDateModal}
          title="Un-saved changes detected"
          question={UNSAVED_MESSAGE}
          yesCallback={() => {
            showUnsavedFiltersModal
              ? this.handleUnsavedFilterDialog(true)
              : this.handleUnsavedSiteDateDialog(true);
          }}
          noCallback={() => {
            showUnsavedFiltersModal
              ? this.handleUnsavedFilterDialog(false)
              : this.handleUnsavedSiteDateDialog(false);
          }}
        />
        <NotificationDialog
          title={'Adjustment Orders'}
          showDialog={showNotificationModal}
          message={message}
          onOkClick={hideNotificationModal}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(CREATE_EDIT_ADJUSTMENT_FORM_NAME);
const mapStateToProps = state => {
  return {
    adjustmentDT: selector(state, [AdjustmentEnum.TransactionDT]),
    adjustmentItemsInfo: selector(state, [AdjustmentEnum.AdjustmentItemsInfo]),
    Site: selector(state, [AdjustmentEnum.Site]),

    assignItemsBidGroupData: FilterSelectors.selectBidGroupData(state),
    assignItemsItemGroupData: FilterSelectors.selectItemGroupData(state),
    adjustmentItemsData: CreateEditSelectors.getAdjustmentItems(state),
    fetchingAdjustmentDetail: CreateEditSelectors.getFetchingAdjustmentDetail(
      state
    ),
  };
};

CreateEditAdjustmentContainer = reduxForm({
  form: CREATE_EDIT_ADJUSTMENT_FORM_NAME,
  destroyOnUnmount: false,
})(CreateEditAdjustmentContainer);

const mapDispatchToProps = {
  resetForm,
  resetDirty,
  ...actions,
};

export const CreateEditAdjustment = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEditAdjustmentContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/containers/createEditAdjustment/CreateEditAdjustmentContainer.js